function Node () {

}

Node.prototype.type = 'Node'

module.exports = Node



//////////////////
// WEBPACK FOOTER
// ./node_modules/mr-parser/lib/node/Node.js
// module id = FdF0
// module chunks = 0